import React  from 'react';

const ColumnWidget = ({children}) => {
    return (
        <div className="w-col">
            {children}
        </div>
    );
}

export default ColumnWidget;
